import { BaseEntity } from "./BaseEntity";


export class SharedEntity extends BaseEntity {
    providerMappings: { [key: string]: string; };
}

